import uniqBy from 'lodash/uniqBy';

export const piperGrades = [
  { label: 'Poppy Part-Time', value: 'PPT' },
  { label: 'Poppy', value: 'P' },
  { label: 'Poppy 1', value: 'P1' },
  { label: 'Poppy 2', value: 'P2' },
  { label: 'Poppy 3', value: 'P3' },
  { label: 'Johnny 1', value: 'J1' },
  { label: 'Johnny 2', value: 'J2' },
  { label: 'Johnny 3', value: 'J3' },
  { label: 'Johnny 4', value: 'J4' },
  { label: 'Ruby 1', value: 'R1' },
  { label: 'Ruby 2', value: 'R2' },
  { label: 'Ruby 3', value: 'R3' },
  { label: 'Ruby 4', value: 'R4' },
  { label: 'Bluebell 1', value: 'B1' },
  { label: 'Bluebell 2', value: 'B2' },
] as const;

export const fairmontGrades = [
  {
    label: 'Pre-School',
    value: 'PS',
  },
  {
    label: 'Pre-K',
    value: 'PK',
  },
  {
    label: 'Junior Kindergarten',
    value: 'JK',
  },
  {
    label: 'Kindergarten',
    value: 'K',
  },
  {
    label: 'Foundations 1-6',
    value: 'F1-6',
  },
  {
    label: '1st Grade',
    value: '1',
  },
  {
    label: '2nd Grade',
    value: '2',
  },
  {
    label: '3rd Grade',
    value: '3',
  },
  {
    label: '4th Grade',
    value: '4',
  },
  {
    label: '5th Grade',
    value: '5',
  },
  {
    label: '6th Grade',
    value: '6',
  },
  {
    label: '7th Grade',
    value: '7',
  },
  {
    label: '8th Grade',
    value: '8',
  },
  {
    label: '9th Grade',
    value: '9',
  },
  {
    label: '10th Grade',
    value: '10',
  },
  {
    label: '11th Grade',
    value: '11',
  },
  {
    label: '12th Grade',
    value: '12',
  },
] as const;

export const grades = [
  {
    label: 'Pre-School',
    value: 'PS',
  },
  {
    label: 'Pre-K',
    value: 'PK',
  },
  {
    label: 'Junior Kindergarten',
    value: 'JK',
  },
  {
    label: 'Kindergarten',
    value: 'K',
  },
  {
    label: '1st Grade',
    value: '1',
  },
  {
    label: '2nd Grade',
    value: '2',
  },
  {
    label: '3rd Grade',
    value: '3',
  },
  {
    label: '4th Grade',
    value: '4',
  },
  {
    label: '5th Grade',
    value: '5',
  },
  {
    label: '6th Grade',
    value: '6',
  },
  {
    label: '7th Grade',
    value: '7',
  },
  {
    label: '8th Grade',
    value: '8',
  },
  {
    label: '9th Grade',
    value: '9',
  },
  {
    label: '10th Grade',
    value: '10',
  },
  {
    label: '11th Grade',
    value: '11',
  },
  {
    label: '12th Grade',
    value: '12',
  },
] as const;

export const southernHighlandsGrades = [
  {
    label: 'Toddler',
    value: 'T',
  },
  {
    label: 'Beginner',
    value: 'BG',
  },
  {
    label: 'Intermediate',
    value: 'I',
  },
  {
    label: 'Pre-K',
    value: 'PK',
  },
  {
    label: 'Junior Kindergarten',
    value: 'JK',
  },
  {
    label: 'Kindergarten',
    value: 'K',
  },
  {
    label: '1st Grade',
    value: '1',
  },
  {
    label: '2nd Grade',
    value: '2',
  },
  {
    label: '3rd Grade',
    value: '3',
  },
  {
    label: '4th Grade',
    value: '4',
  },
  {
    label: '5th Grade',
    value: '5',
  },
  {
    label: '6th Grade',
    value: '6',
  },
  {
    label: '7th Grade',
    value: '7',
  },
  {
    label: '8th Grade',
    value: '8',
  },
] as const;

export const merryhillGrades = [
  {
    label: 'Infant',
    value: 'INF',
  },
  {
    label: 'Toddler',
    value: 'T',
  },
  {
    label: 'Beginner',
    value: 'BG',
  },
  {
    label: 'Intermediate',
    value: 'I',
  },
  {
    label: 'Pre-K',
    value: 'PK',
  },
  {
    label: 'Junior Kindergarten',
    value: 'JK',
  },
  {
    label: 'Kindergarten',
    value: 'K',
  },
  {
    label: '1st Grade',
    value: '1',
  },
  {
    label: '2nd Grade',
    value: '2',
  },
  {
    label: '3rd Grade',
    value: '3',
  },
  {
    label: '4th Grade',
    value: '4',
  },
  {
    label: '5th Grade',
    value: '5',
  },
  {
    label: '6th Grade',
    value: '6',
  },
  {
    label: '7th Grade',
    value: '7',
  },
  {
    label: '8th Grade',
    value: '8',
  },
] as const;

export const ourLadyOfFatimaGrades = [
  {
    label: 'Three Year Old Program',
    value: '3YO',
  },
  {
    label: 'Transitional Kindergarten',
    value: 'TK',
  },
  {
    label: 'Kindergarten',
    value: 'K',
  },
  {
    label: '1st Grade',
    value: '1',
  },
  {
    label: '2nd Grade',
    value: '2',
  },
  {
    label: '3rd Grade',
    value: '3',
  },
  {
    label: '4th Grade',
    value: '4',
  },
  {
    label: '5th Grade',
    value: '5',
  },
  {
    label: '6th Grade',
    value: '6',
  },
  {
    label: '7th Grade',
    value: '7',
  },
  {
    label: '8th Grade',
    value: '8',
  },
] as const;

export const sapoluDestinedAcademyGrades = [
  {
    label: '6th Grade',
    value: '6',
  },
  {
    label: '7th Grade',
    value: '7',
  },
  {
    label: '8th Grade',
    value: '8',
  },
  {
    label: '9th Grade',
    value: '9',
  },
] as const;

const ahaGrades = [
  { label: 'Kinder Prep', value: 'KP' },
  ...grades.filter((grade) => !['PS', 'PK', 'JK'].includes(grade.value)),
];

export const allGrades = uniqBy(
  [
    ...grades,
    ...fairmontGrades,
    ...piperGrades,
    ...ahaGrades,
    ...southernHighlandsGrades,
    ...merryhillGrades,
    ...ourLadyOfFatimaGrades,
    ...sapoluDestinedAcademyGrades,
  ],
  'value'
);

export type GradeValues = (typeof allGrades)[number]['value'];

export const selectGradeLabel = (value: string | null) => {
  if (!value) return null;
  const grade = allGrades.find((g) => g.value === value);
  return grade ? grade.label : null;
};
